module.exports = __webpack_public_path__ + "img/position.81243339.svg";